import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';
const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (method === "post" || method === "put" || method === "delete") {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    //Report Tables
    async getReportTables(accessToken) {
        return await this.execute('get', `/ReportTable`, null, accessToken);
    },
    async searchReportTableColumns(parentId, searchText, pageNo, pageSize, orderBy, sorting, accessToken) {
        return await this.execute('get', `/ReportTable/columns/search?parentId=${parentId}&searchText=${searchText}&pageNo=${pageNo}&pageSize=${pageSize}&orderBy=${orderBy}&sorting=${sorting}`, null, accessToken);
    },
    async getReportTableDefinitions(reportTableId, accessToken) {
        return await this.execute('get', `/ReportTable/${reportTableId}/columns`, null, accessToken);
    },
    async getReportTableColumnById(reportTableColumnId, accessToken) {
        return await this.execute('get', `/ReportTable/column/${reportTableColumnId}`, null, accessToken);
    },
    async createReportTableColumn(reportTableId, reportTableColumn, accessToken) {
        return await this.execute('post', `/ReportTable/${reportTableId}`, reportTableColumn, accessToken);
    },
    async updateReportTableColumn(reportTableColumnId, request, accessToken) {
        return await this.execute('put', `/ReportTable/column/${reportTableColumnId}`, request, accessToken);
    },
}
